<template>
    <div class="edit-horario">
        <h2 class="title">{{ value.horario + 1 + 'º ' + $t('horario') }}</h2>
        <div class="inputs">
            <div class="entry-time">
                <label v-text="$t('horario-entrada')" />
                <the-mask
                    ref="dateInInput"
                    :masked="true"
                    id="entrada"
                    type="text"
                    v-model="temp.entrada"
                    :mask="['##:##']"
                    :placeholder="$t('hora-placeholder')"
                />
            </div>
            <div class="end-time">
                <label v-text="$t('horario-saida')" />
                <the-mask
                    ref="dateOutInput"
                    :masked="true"
                    id="saida"
                    type="text"
                    v-model="temp.saida"
                    :mask="['##:##']"
                    :placeholder="$t('hora-placeholder')"
                />
            </div>
        </div>
        <div class="repeat">
            <label> {{ $t('repetir') }}: </label>
            <div class="days-of-week">
                <fSwitch
                    :text="$t('segunda')"
                    :checked="temp.copiar.segunda"
                    :onChange="checkSegunda"
                />
                <fSwitch :text="$t('terca')" :checked="temp.copiar.terca" :onChange="checkTerca" />
                <fSwitch
                    :text="$t('quarta')"
                    :checked="temp.copiar.quarta"
                    :onChange="checkQuarta"
                />
                <fSwitch
                    :text="$t('quinta')"
                    :checked="temp.copiar.quinta"
                    :onChange="checkQuinta"
                />
                <fSwitch :text="$t('sexta')" :checked="temp.copiar.sexta" :onChange="checkSexta" />
                <fSwitch
                    :text="$t('sabado')"
                    :checked="temp.copiar.sabado"
                    :onChange="checkSabado"
                />
                <fSwitch
                    :text="$t('domingo')"
                    :checked="temp.copiar.domingo"
                    :onChange="checkDomingo"
                />
                <fSwitch
                    :text="$t('todos-os-dias')"
                    :checked="temp.copiar.todos"
                    :onChange="selectAll"
                />
            </div>
        </div>
        <div class="form-buttons">
            <button class="cancel-btn" type="button" @click="close()">
                {{ $t('cancelar') }}
            </button>
            <button class="delete-btn" type="button" @click="excluiHorario()">
                {{ $t('deletar-btn-do-promotor-placeholder') }}
            </button>
            <button class="save-btn" type="button" @click="saveChanges(value)">
                {{ $t('salvar') }}
            </button>
        </div>
    </div>
</template>

<script>
import SelectBox from '@/components/shared/form/SelectBox.vue';
import fSwitch from '@/components/shared/form/Switch.vue';

export default {
    props: ['value'],
    components: {
        SelectBox,
        fSwitch,
    },
    data() {
        return {
            avo: this.$parent.$parent,
            temp: {
                entrada: '00:00',
                saida: '00:00',
            },
        };
    },
    created() {
        if (!this.value.entrada) {
            this.temp = {
                entrada: '00:00',
                saida: '00:00',
                dia: this.value.dia,
                horario: this.value.horario,
                copiar: {
                    segunda: this.value.dia == 0,
                    terca: this.value.dia == 1,
                    quarta: this.value.dia == 2,
                    quinta: this.value.dia == 3,
                    sexta: this.value.dia == 4,
                    sabado: this.value.dia == 5,
                    domingo: this.value.dia == 6,
                },
            };
        } else {
            this.temp = {
                entrada: this.value.entrada,
                saida: this.value.saida,
                dia: this.value.dia,
                horario: this.value.horario,
                copiar: {
                    segunda: this.value.dia == 0,
                    terca: this.value.dia == 1,
                    quarta: this.value.dia == 2,
                    quinta: this.value.dia == 3,
                    sexta: this.value.dia == 4,
                    sabado: this.value.dia == 5,
                    domingo: this.value.dia == 6,
                },
            };
        }
        this.temp.copiar.todos =
            this.temp.copiar.segunda &&
            this.temp.copiar.terca &&
            this.temp.copiar.quarta &&
            this.temp.copiar.quinta &&
            this.temp.copiar.sexta &&
            this.temp.copiar.sabado &&
            this.temp.copiar.domingo;
    },
    mounted() {
        let dateInInput = this.$refs.dateInInput.$el;
        dateInInput.addEventListener('blur', () => {
            if (!this.validateHour(this.temp.entrada)) {
                this.temp.entrada = '00:00';
            }
        });

        let dateOutInput = this.$refs.dateOutInput.$el;
        dateOutInput.addEventListener('blur', () => {
            if (!this.validateHour(this.temp.saida)) {
                this.temp.saida = '00:00';
            }
        });
    },
    methods: {
        getClients() {
            if (!this.value.publicar) {
                return '';
            } else {
                return !this.value.publicar;
            }
        },
        saveChanges() {
            this.temp.entrada = this.formatValue(this.temp.entrada);
            this.temp.saida = this.formatValue(this.temp.saida);
            this.avo.$emit('update-data', this.temp);
            this.close();
        },
        excluiHorario() {
            this.avo.$emit('excluir-horario', this.temp);
            this.close();
        },
        selectAll(e) {
            this.temp.copiar.segunda = e.target.checked;
            this.temp.copiar.terca = e.target.checked;
            this.temp.copiar.quarta = e.target.checked;
            this.temp.copiar.quinta = e.target.checked;
            this.temp.copiar.sexta = e.target.checked;
            this.temp.copiar.sabado = e.target.checked;
            this.temp.copiar.domingo = e.target.checked;
            this.temp.copiar.todos = e.target.checked;
        },
        checkTodos() {
            this.temp.copiar.todos =
                this.temp.copiar.segunda &&
                this.temp.copiar.terca &&
                this.temp.copiar.quarta &&
                this.temp.copiar.quinta &&
                this.temp.copiar.sexta &&
                this.temp.copiar.sabado &&
                this.temp.copiar.domingo;
        },
        checkSegunda(e, val) {
            this.temp.copiar.segunda = e.target.checked;
            this.checkTodos();
        },
        checkTerca(e, val) {
            this.temp.copiar.terca = e.target.checked;
            this.checkTodos();
        },
        checkQuarta(e, val) {
            this.temp.copiar.quarta = e.target.checked;
            this.checkTodos();
        },
        checkQuinta(e, val) {
            this.temp.copiar.quinta = e.target.checked;
            this.checkTodos();
        },
        checkSexta(e, val) {
            this.temp.copiar.sexta = e.target.checked;
            this.checkTodos();
        },
        checkSabado(e, val) {
            this.temp.copiar.sabado = e.target.checked;
            this.checkTodos();
        },
        checkDomingo(e, val) {
            this.temp.copiar.domingo = e.target.checked;
            this.checkTodos();
        },
        close() {
            this.$parent.closeModal();
        },
        formatValue(value) {
            return value.substring(0, 5);
        },
    },
};
</script>

<style lang="scss" scoped>
// @import "../../../../styles.scss";

.edit-horario {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    > h2 {
        width: 100%;
        font-weight: 600;
        line-height: normal;
        font-size: 31px;

        color: $primary-color;
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    > .inputs {
        width: 48%;
        position: relative;
        margin-bottom: 20px;
        margin-top: 30px;
    }

    > .repeat {
        width: 35%;
        position: relative;
        height: 100%;
        margin-left: 40px;
        margin-top: -45px;

        > .days-of-week {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 35px 20px;
            border: 1px solid #dddddd;
            box-sizing: border-box;
            border-radius: 10px;
            margin-left: 40px;

            > .obrigatorio {
                width: 30%;
                margin-bottom: 10px;
            }
        }

        > label {
            margin-top: -30px;
        }
    }

    label {
        color: $darker-gray-color;
        font-weight: 600;
        line-height: normal;
        font-size: 12px;
        letter-spacing: 0.26px;
    }

    > .form-buttons {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: flex-end;

        > .save-btn,
        > .cancel-btn,
        > .delete-btn {
            // position: relative;
            color: $sovis-white;
            font-size: 12px;
            text-align: center;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px;
            @include gradient-button();

            cursor: pointer;
        }

        > .cancel-btn,
        > .delete-btn {
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
}
</style>
